import Helper from "../Helper";

export default class PaginationWithNumbers {

  /**
   * @constructor
   */
    constructor()
    {
        window.showHotelIDs = [];
        this.countOfNumber = 0;
        this.countForOtherSide = 0;
        this.$activePage = $('[data-set-active-page]');
        this.maxNumberOfPage = $('[data-max-count-of-page]').data('maxCountOfPage') - 1;
        this.$entites = $('[data-entity-position]');
        this.intervalBottom = 0;
        this.intervalTop = 0;
        this.maxOnPage = 0;
        this.scrollToElement = $('[data-pagination-scroll-to-element]');
        this.frontArrow = $('[data-type-arrow="+"]');
        this.backArrow = $('[data-type-arrow="-"]')

        this.init();
    }

    init()
    {
        $(document).ready(() => {
            if (Helper.isMobileOrLower()) {
                this.countOfNumber = 1;
                this.countForOtherSide = 0;
            } else {
                this.countOfNumber = 2;
                this.countForOtherSide = 1;
            }
      
            this.initDependencies($('#map').length > 0);

            if ($('[data-set-active-page]').length > 0) {
                $('[data-set-active-page="0"]').click();
            } else {
                Helper.initSliderGallery(1);
            }
        });

    }

  /**
   * Function that inits dependencies
   *
   * @param {boolean} updateMap
   */
    initDependencies(updateMap)
    {
        if ($('[data-set-active-page]').length > 0) {
            $('[data-set-active-page]').click((event) => {
                this.setActivePage(event, updateMap)
            });
        }
        if ($('[data-type-arrow]').length > 0) {
            $('[data-type-arrow]').click((event) => {
                this.scrollPage(event)
            });
        }
    }

  /**
   * This function set active page.
   *
   * @param {Event} e clicked active page
   * @param {boolean} updateMap
   */
    setActivePage(e, updateMap)
    {
        let countOfNumbers = this.$activePage.length;
        let element = $(e.target);

        let pageNumber = element.data('setActivePage');

        this.setActivePageClass(element, pageNumber, updateMap);

        if (pageNumber === 2) {
            this.hideOrShowSpecificNumber(3);
        }

        this.hideOrShowNumbers(pageNumber, countOfNumbers);
    
        if (!(e.originalEvent === undefined)) {
            this.scrollToTop();
        }

        Helper.initSliderGallery(pageNumber + 1);
    }

  /**
   * this function set class active and no active add add current page number
   *
   * @param {element} e element
   * @param {int} pageNumber number of data attribute
   * @param {boolean} updateMap
   */
    setActivePageClass(e, pageNumber, updateMap)
    {
        window.showHotelIDs = [];
        this.intervalBottom = pageNumber * this.maxNumberOfPage + pageNumber;
        this.intervalTop = (pageNumber + 1) * this.maxNumberOfPage + pageNumber;

        this.$entites.each((index, e) => {
            if (parseInt($(e).data('entityPosition')) >= this.intervalBottom && parseInt($(e).data('entityPosition')) <= this.intervalTop) {
                $(e).removeClass('hidden-mvio');
                window.showHotelIDs.push($(e).data('id'));
                this.maxOnPage = $(e).data('entityPosition');
            } else {
                $(e).addClass('hidden-mvio');
            }
        })

        this.$activePage.removeClass('pagination-number--active');
        this.$activePage.addClass('pagination-number--no-active');

        $(e).addClass('pagination-number--active');
        $(e).removeClass('pagination-number--no-active');

        $('[data-current-page-number]').each(function (index) {
            $(this).data('currentPageNumber', pageNumber);
        });

        if (updateMap) {
            window.updateMap();
        }
    }

  /**
   * this function hide or show specific number
   *
   * @param number
   */
    hideOrShowSpecificNumber(number)
    {
        let element = $('[data-set-active-page="' + number + '"]');
        let after = number + 1;
        let before = number - 1;
        if (element.hasClass('hide-number')) {
            $('[data-dots-after="' + before + '"]').remove();
            element.removeClass('hide-number');

            if ($('[ data-dots-after="' + after + '"]').length === 0) {
                element.after(' <p class="dots" data-dots-after="' + after + '">...</p>');
            }
        } else {
            element.addClass('hide-number');
            $(['data-dots-after="' + after + '"']).remove();
        }
    }

  /**
   * This function display or hide numbers after click on number in pagination or arrow
   *
   * @param pageNumber
   * @param countOfNumbers
   */
    hideOrShowNumbers(pageNumber, countOfNumbers)
    {
        let after = pageNumber + 1;
        let elementAfter = $('[data-set-active-page="' + after + '"]');

        let before = pageNumber - 1;
        let elementBefore = $('[data-set-active-page="' + before + '"]');

        if (pageNumber === 0 || pageNumber === countOfNumbers - 1) {
            this.resetPaginationOnLeftOrRight(pageNumber, countOfNumbers);

            if (pageNumber === 0) {
                if (!this.backArrow.first().hasClass('hidden-mvio')) {
                    this.backArrow.first().addClass('hidden-mvio');
                }
            } else {
                if (!this.frontArrow.first().hasClass('hidden-mvio')) {
                    this.frontArrow.first().addClass('hidden-mvio');
                }
            }
        } else {
            if (this.backArrow.first().hasClass('hidden-mvio')) {
                this.backArrow.first().removeClass('hidden-mvio');
            }

            if (this.frontArrow.first().hasClass('hidden-mvio')) {
                this.frontArrow.first().removeClass('hidden-mvio');
            }
        }

        if (pageNumber !== 0 && pageNumber !== countOfNumbers - 1) {
            this.$activePage.each((index, element) => {
                if ((index < pageNumber - this.countForOtherSide && index !== 0) || (index > pageNumber + this.countForOtherSide && index !== countOfNumbers - 1)) {
                    $(element).addClass('hide-number');

                    if (pageNumber === this.countOfNumber) {
                        $('[data-dots-after="' + pageNumber + '"]').remove();
                    }

                    if (pageNumber >= this.countOfNumber) {
                        $('[data-dots-after]').remove();

                        if (pageNumber < (countOfNumbers - (this.countOfNumber + 1))) {
                            elementAfter.after('<p class="dots" data-dots-after="' + after + '">...</p>');
                        }
                        if (before !== this.countOfNumber - 1) {
                            elementBefore.before('<p class="dots" data-dots-after="' + before + '">...</p>');
                        }
                    }
                } else {
                    $(element).removeClass('hide-number');
                    if (this.countOfNumber === 1) {
                        $(element).removeClass('pagination-number--hide-under-575');
                    }
                }
            });
        }

        this.changeCount();
    }

  /**
   * This function display after 2 or 1 numbers click on first or last number
   *
   * @param pageNumber
   */
    resetPaginationOnLeftOrRight(pageNumber, countOfNumbers)
    {
        $('[data-dots-after]').remove();

        this.$activePage.each((index, element) => {
            if (pageNumber === 0) {
                if ((index <= this.countOfNumber) || (index === countOfNumbers - 1)) {
                    $(element).removeClass('hide-number');

                    if ((index === this.countOfNumber && countOfNumbers >= 5)) {
                         $(element).after('<p class="dots" data-dots-after="' + index + '">...</p>');
                    }
                } else {
                    $(element).addClass('hide-number');
                }
            } else {
                if (index >= countOfNumbers - (this.countOfNumber + 1) || index === 0) {
                    $(element).removeClass('hide-number');
                    if (index === (countOfNumbers - (this.countOfNumber + 1)) && countOfNumbers >= 5) {
                        $(element).before('<p class="dots" data-dots-after="' + index + '">...</p>');
                    }
                } else {
                    $(element).addClass('hide-number');
                }
            }
        });
    }

  /**
   * This function set active previous or next page
   *
   * @param {Event} e clicked active page arrow for next or previous page
   */
    scrollPage(e)
    {
        let element = $(e.target).closest('[data-type-arrow]');
        let currentPageNumber = element.data('currentPageNumber');
        let type = element.data('typeArrow');
        let countOfNumbers = this.$activePage.length;

        if (((currentPageNumber) !== countOfNumbers - 1) || (type === '-')) {
            if (type === '-' && currentPageNumber !== 0) {
                currentPageNumber = currentPageNumber - 1

                if (this.frontArrow.first().hasClass('hidden-mvio')) {
                    this.frontArrow.first().removeClass('hidden-mvio');
                }

                // if it is the first page
                if (currentPageNumber == 0) {
                    $(element).addClass('hidden-mvio');
                }
            } else if (type === '+' && currentPageNumber <= countOfNumbers - 1) {
                currentPageNumber = currentPageNumber + 1;

                if (this.backArrow.first().hasClass('hidden-mvio')) {
                    this.backArrow.first().removeClass('hidden-mvio');
                }
       
              // if it is the last page
                if (currentPageNumber == countOfNumbers - 1) {
                    $(element).addClass('hidden-mvio');
                }
            }

            $('[data-current-page-number]').each(function (index) {
                $(this).data('currentPageNumber', currentPageNumber);
            });

            $('[data-set-active-page="' + currentPageNumber + '"]').click();

            this.changeCount();
            this.scrollToTop();
        }
    }

  /**
   * This function change count of place to stay
   */
    changeCount()
    {
        $('[data-count-element-on-page]').text((this.intervalBottom + 1) + ' - ' + (this.maxOnPage + 1));
    }

  /**
   * Function that scrolls to the top of selected element
   */
    scrollToTop()
    {
        if ($(this.scrollToElement).data('bodyscroll') === 1 || window.innerWidth <= 1052) {
            Helper.scrollToElement($(this.scrollToElement), -50);
        } else {
            $(this.scrollToElement).animate({
                scrollTop: $(this.scrollToElement).offset().top - 50
            }, 1000);
        }
    }
}